//@flow
import React from 'react';
import {Button, makeStyles, Menu} from '@material-ui/core';
import {ExpandLess, ExpandMore} from '@material-ui/icons';

type Classes = {
  button?: string,
  menu?: string,
  label?: string,
};

type Props = {
  label: string,
  children: React$Node,
  variant?: 'text' | 'outlined' | 'contained',
  color?: 'primary' | 'secondary',
  disabled?: boolean,
  classes?: Classes,
  onClose?: () => void,
};

const useStyles = makeStyles(theme => ({
  openButton: {
    textTransform: 'none',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',

    gap: theme.spacing(1),
    borderRadius: '1rem',
    fontSize: '.9rem',
    padding: '0.125rem 1rem',
    boxShadow: 'none',

    '&:hover': {
      boxShadow: 'none',
    },
  },
  buttonIcon: {
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  options: {
    width: '20rem',
    background: 'white',
    borderRadius: '1rem',
    boxShadow: '0px 4px 30px rgba(113, 113, 113, 0.15)',
    paddingInline: '.5rem',
  },
}));

export default function PillSelect(props: Props) {
  const {
    label,
    variant = 'contained',
    color = 'primary',
    children,
    disabled,
    onClose,
    classes: customClasses = {},
  } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    onClose && onClose();
  };

  return (
    <div className={classes.root}>
      <Button
        color={color}
        variant={variant}
        disabled={disabled}
        className={`${classes.openButton} ${customClasses.button || ''}`}
        onClick={handleClick}
      >
        <span className={customClasses.label}>{label}</span>
        <span className={classes.buttonIcon}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </span>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        classes={{
          paper: `${classes.options} ${classes.menu}`,
        }}
      >
        {children}
      </Menu>
    </div>
  );
}
